import styled from "styled-components";
import { format, parseISO } from "date-fns";

import { Spacing, Text } from "@otta/design";
import { pxToRem, palette } from "@otta/design-tokens";
import { Company } from "@otta/search/schema";

const Container = styled.div<{ isLast: boolean }>`
  padding: ${pxToRem(20)} 0 ${pxToRem(30)};
  border-bottom: ${({ isLast }) =>
    isLast ? "none" : `2px solid ${palette.brand.grey}`};
  color: ${palette.brand.black};
`;

const SurveyInfo = styled.div`
  display: flex;
  align-items: center;
`;

const Profile = styled.div`
  border-radius: 50%;
  background-color: ${palette.brand.grey};
  height: ${pxToRem(44)};
  width: ${pxToRem(44)};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: ${pxToRem(10)};
`;

const StyledDate = styled.div`
  color: ${palette.grayscale.shade600};
`;

interface ISurveyProps {
  survey: Company.EmployeeSurveys;
  isLast: boolean;
}

export function Survey({ survey, isLast }: ISurveyProps): React.ReactElement {
  return (
    <Container isLast={isLast}>
      <Spacing size={3}>
        <SurveyInfo>
          <Profile>{survey.jobFunction.value.charAt(0)}</Profile>
          <div>
            <Text>
              Employee in the{" "}
              <Text as="span" bold>
                {survey.jobFunction.value}
              </Text>{" "}
              team
            </Text>
            <StyledDate>
              {survey.submittedAt &&
                format(parseISO(survey.submittedAt), "MMM yyyy")}
            </StyledDate>
          </div>
        </SurveyInfo>
        <Spacing size={2}>
          {survey.responses.map(response => (
            <Spacing key={response.id}>
              <Text bold>{response.category.name}</Text>
              <Text>{response.content}</Text>
            </Spacing>
          ))}
        </Spacing>
      </Spacing>
    </Container>
  );
}
